import { fieldAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const fieldSlotRecipe = defineSlotRecipe({
  className: 'field',
  slots: fieldAnatomy.keys(),
  base: {
    root: {
      width: '100%',
      _invalid: {
        width: '100%',
      },
    },
    label: {
      display: 'flex',
      gap: '4',
      alignItems: 'center',
      width: '100%',
      color: 'input/text/label',
      textStyle: 'comp/input/label',
      marginBlockEnd: '4',
      '& > span': {
        marginInlineStart: '2',
        color: 'text/helper',
        fontWeight: 'normal',
      },
      '[data-disabled] &': {
        color: 'text/disabled',
        '& > span': {
          color: 'text/disabled',
        },
      },
    },
    errorText: {
      display: 'block',
      marginBlockStart: '4',
      textStyle: 'comp/input/helperText',
      color: 'input/text/error',
    },
    helperText: {
      display: 'block',
      marginBlockStart: '4',
      textStyle: 'comp/input/helperText',
      color: 'text/helper',
      '[data-disabled] &': {
        color: 'text/disabled',
      },
    },
  },
});

export default fieldSlotRecipe;
